/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Html_Studio_SubtitleInputs */

const cs_builder_html_studio_subtitle = /** @type {(inputs: Builder_Html_Studio_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pište dokument na stránce. Tokeny polí doplní CRM data při generování.`)
};

const en_builder_html_studio_subtitle = /** @type {(inputs: Builder_Html_Studio_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write the document on the page. Field tokens pull CRM data when you generate.`)
};

/**
* | output |
* | --- |
* | "Write the document on the page. Field tokens pull CRM data when you generate." |
*
* @param {Builder_Html_Studio_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_html_studio_subtitle = /** @type {((inputs?: Builder_Html_Studio_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Html_Studio_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_html_studio_subtitle(inputs)
	return cs_builder_html_studio_subtitle(inputs)
});